export const DateConst = {
  DATE_FORMAT: 'MM/dd/yyyy',
  TIME_FORMAT: 'H:mm a',
  TRANSFORM_DATE_FORMAT: 'yyyy-MM-dd',
  HOUR_MS_OFFSET: 60000,
  DATE_FORMAT_REGEX: /^[0-9]{4}-[0-9]{2}-[0-9]{2}$/,
  PERMANENTS: [3, 6],
};
